import React from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import FastRewindIcon from "@material-ui/icons/FastRewind";
import PauseIcon from "@material-ui/icons/Pause";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import FastForwardIcon from "@material-ui/icons/FastForward";
import Typography from "@material-ui/core/Typography";
import {useAudio} from 'react-use'
import AllIWant from './songs/Mariah Carey - All I Want for Christmas Is You (Make My Wish Come True Edition).mp3'
import WhereAreYou from './songs/Faith Hill - Where Are You Christmas.mp3'
import FelizNavidad from './songs/Feliz Navidad- Jose Feliciano lyrics [HQ].mp3'
import JingleBell from './songs/Jingle Bell Rock- Lyrics.mp3'
import Rudolph from './songs/Rudolph The Red Nosed Reindeer Lyrics.mp3'
import Santa from './songs/Santa Claus Is Coming To Town.mp3'
import JingleBells from './songs/Frank Sinatra - Jingle Bells (Official Video).mp3'
import Hidden from '@material-ui/core/Hidden'




export const MP3Player = (props) => {
  let songs = React.useMemo(() => {
    return [
      {name: 'All I Want For Christmas Is You', song: AllIWant},
      {name: 'Jingle Bells', song: JingleBell},
      {name: 'Where Are you Christmas', song: WhereAreYou},
      {name: 'Feliz Navidad', song: FelizNavidad},
      {name: 'Rudolph The Red Nosed Reindeer', song: Rudolph},
      // {name: 'Santa Claus Is Coming To Town', song: Santa},
    ]
  },[])

  const [song, setSong] = React.useState(0)


  const [audio, state, controls] = useAudio({
    src: songs[song] && songs[song].song ? songs[song].song:null,
    autoPlay: true,
  })

  const handleForward = e => {
    if (song !== songs.length -1) {
      setSong(song + 1)
    }
    else setSong(0)
  }

  const handleBackward = e => {
    if (song !== 0) {
      setSong(song - 1)
    }
    else setSong(songs.length - 1)
  }

  return (
    <div style={{flexGrow: 1}}>
    <div style={{width: 150, zIndex: 300}}>
      {audio}
      <Grid item xs={12} container justify={'center'} alignContent={'center'}>
        <Grid item xs={4}>
          <IconButton onClick={handleBackward} color={'inherit'} style={{color: '#272730'}}>
            <FastRewindIcon/>
          </IconButton>
        </Grid>
        <Grid item xs={4}>
          <IconButton onClick={() => state.paused ? controls.play():controls.pause()} color={'inherit'} style={{color: '#272730'}}>
            {state.paused ? <PlayArrowIcon/>:<PauseIcon/>}
          </IconButton>
        </Grid>
        <Grid item xs={4}>
          <IconButton onClick={handleForward} color={'inherit'} style={{color: '#272730'}}>
            <FastForwardIcon/>
          </IconButton>
        </Grid>
        <Grid item xs={12} style={{position: 'absolute', top : 15}}>
          <Typography variant={'body2'} align='center' style={{fontSize: 10, color: '#272730', fontWeight: 600, }}>
            {!state.paused ? songs[song].name:''}
          </Typography>
        </Grid>
      </Grid>
      {/*<div style={{position: 'fixed', width: '100%', left: 5, top: 5}}>*/}
      {/*</div>*/}
    </div>
    </div>
  )

}
